import React, { useState } from 'react';
import css from './FilterSidebar.module.css';
import { FormattedMessage } from 'react-intl';
import { Icons, PrimaryButton } from '../../../components';
import classNames from 'classnames';

const LocationFilterSection = ({
  handleClearFilter,
  updateURLParams,
  heading,
  paramKey,
  isBlackBgFilter,
  isTalentOfferingFilters,
}) => {
  const [location, setLocation] = useState('');

  const handleApply = () => {
    updateURLParams('keywords', [location]);
    setLocation('');
  };

  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <div className={classNames(isBlackBgFilter ? css.blackBgFilter : null, css.sectionHeader)}>
          <h3>{heading}</h3>
          <button
            className={css.clearButton}
            onClick={() => {
              handleClearFilter(paramKey);
              setLocation('');
            }}
          >
            <FormattedMessage id="FilterCategories.clear" />
          </button>
        </div>
      )}
      <div className={css.scrollable}>
        <div className={css.locationSearchFld}>
          <div className={css.searchKeywordSec}>
            <PrimaryButton onClick={handleApply} className={css.applyButton}>
              <Icons name="search" className={css.searchIcon} />
            </PrimaryButton>
            <input
              type="text"
              className={css.searchInput}
              placeholder="Enter location..."
              value={location}
              onChange={e => setLocation(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationFilterSection;
